export function splitTextInArray(text) {
  return Array.from(text);
}

export function matchIsLastArrayItem(item, array) {
  return array[array.length - 1] === item;
}


export function backgroundImageGenerator(backgrounds) {
  if (!Array.isArray(backgrounds) || backgrounds.length === 0) {
    throw new Error("The input should be a non-empty array of background objects.");
  }

  let currentIndex = 0;

  return function getNextBackground() {
    const background = backgrounds[currentIndex];
    currentIndex = (currentIndex + 1) % backgrounds.length;
    return background;
  };
}